module.exports = __webpack_public_path__ + "static/media/john-hunter-and-the-mayan-gods.444e6b52.gif";